import { jsx as _jsx } from "react/jsx-runtime";
import { useDraggable } from '@dnd-kit/core';
function Draggable(props) {
    const { id, data, style: propsStyle } = props;
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id,
        data,
    });
    const style = Object.assign(Object.assign({}, propsStyle), { opacity: isDragging ? 0.5 : 1 });
    return (_jsx("div", Object.assign({ ref: setNodeRef, style: style }, listeners, attributes, { children: props.children })));
}
export default Draggable;
